import Occasion from "../stores/domainStore/pages/models/occasion";
import {IBackendCaller} from "./backendCaller";

const occasionDefaultURL = "/api/occasions";

// The interface for OccasionService.
export interface IOccasionService {
  /*
   * A GET call to get a list of occasions within a given date range.
   */
  getOccasions: (
    startDate: string,
    endDate: string,
    villageIds?: string,
    abortController?: AbortController
  ) => Promise<any>;

  /*
   * A GET call to get a single occasion by ID.
   */
  getOccasion: (id: string, abortController?: AbortController) => Promise<any>;

  /*
   * A POST call to create a new occasion.
   */
  createOccasion: (createOccasion: Occasion) => Promise<any>;

  /*
   * A PUT call to update an existing occasion.
   */
  updateOccasion: (id: string, updateOccasion: Occasion) => Promise<any>;

  /*
   * A DELETE call to delete an occasion by ID.
   */
  deleteOccasion: (id: string) => Promise<any>;
}

export class OccasionService implements IOccasionService {
  backendCaller: IBackendCaller;

  constructor(backendCaller: IBackendCaller) {
    this.backendCaller = backendCaller;
  }

  getOccasions = async (
    startDate: string,
    endDate: string,
    villageIds?: string,
    abortController?: AbortController
  ) => {
    let url = `${occasionDefaultURL}?startDate=${startDate}&endDate=${endDate}`;
    if (villageIds) {
      url += `&villageIds=${villageIds}`;
    }

    return await this.backendCaller.callApi(
      "GET",
      url,
      null,
      null,
      false,
      abortController
    );
  };

  getOccasion = async (id: string, abortController?: AbortController) => {
    return await this.backendCaller.callApi(
      "GET",
      `${occasionDefaultURL}/${id}`,
      null,
      null,
      false,
      abortController
    );
  };

  createOccasion = async (createOccasion: Occasion) => {
    return await this.backendCaller.callApi(
      "POST",
      occasionDefaultURL,
      JSON.stringify(createOccasion.toJson())
    );
  };

  updateOccasion = async (id: string, updateOccasion: Occasion) => {
    return await this.backendCaller.callApi(
      "PUT",
      `${occasionDefaultURL}/${id}`,
      JSON.stringify(updateOccasion.toJson())
    );
  };

  deleteOccasion = async (id: string) => {
    return await this.backendCaller.callApi(
      "DELETE",
      `${occasionDefaultURL}/${id}`
    );
  };
}
